import { HttpClient } from '@angular/common/http';
import { Injectable, Signal, inject, signal } from '@angular/core';
import { BehaviorSubject, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ServiceSearchResult } from '../models/searchresult.model';

@Injectable({
  providedIn: 'root'
})
export class SearchServiceService {
  http = inject(HttpClient);
  private API_URL = environment.config.backendUrl;
  _searchResults = signal<ServiceSearchResult[]>([]);
  searchResults: Signal<ServiceSearchResult[]> = this._searchResults.asReadonly();
  _allServices = signal<ServiceSearchResult[]>([]);
  allServices: Signal<ServiceSearchResult[]> = this._allServices.asReadonly();
  alreadySearched: boolean = false;
  startResultIndex: number = 0;
  noMoreResults: boolean = false;
  itemPerSearch: number = 6;
  loading = signal(false);
  totalLength: BehaviorSubject<number> = new BehaviorSubject(0);

  isLoading() {
    return this.loading();
  }
  ESQuerySearch(term: string = '', startIndex: number) {
    let query =
    {
      "from": startIndex,
      "size": this.itemPerSearch,
      "query": {
        "bool": {
          "must": [
            {
              "multi_match": {
                "query": term,
                "type": "phrase_prefix",
                "fields": [
                  "data.title^50",
                  "data.service_short_description^10",
                  "*"
                ],
              }
            }
          ]
        }
      }
    };
    return this.http.post(`${this.API_URL}/api/search/service`, query);
  }

  getAllByTypeServices(page: number = this.startResultIndex, limit: number = this.itemPerSearch, sort: string = 'title') {
    return this.http.get(`${this.API_URL}/api/services?filter[status][value]=1&jsonapi_include=1&sort=${sort}&page[offset]=${page}&page[limit]=${limit}`);
  }


  getAllServices() {
    this.loading.set(true);

    this.getAllByTypeServices().pipe(
      map((res: any) => {
        console.log(res.meta.count);
        this.totalLength.next(res.meta.count);
        const adaptedData = res.data.map((item: any) => {
          return {
            type: item.type,
            title: item.title,
            shortDescription: item.service_short_description,
            category: item.service_category,
            path: item?.path?.alias,
          };
        });
        return adaptedData;
      }),
    ).subscribe((result: ServiceSearchResult[]) => {
      if (result?.length < this.itemPerSearch) {
        this.noMoreResults = true;
      } else if (result.length === this.itemPerSearch) {
        // Rimuovo l'ultimo elemento, ma tengo attivo il pulsante carica altri elementi
        result.pop();
      }
      if (this._allServices().length) {
        this._allServices.update(searchArr => {
          searchArr = [...searchArr, ...result];
          this.startResultIndex = searchArr.length;
          return searchArr;
        });
      } else {

        this._allServices.set(result);
        this.startResultIndex = result.length;
      }

      this.loading.set(false);

    }
    );
  }

  cleanResults() {
    this.startResultIndex = 0;
    this.noMoreResults = false;
    this._searchResults.set([]);
    this._allServices.set([]);
  }

  search(wordToSearch: string) {

    this.loading.set(true);
    this.alreadySearched = true;
    this.ESQuerySearch(wordToSearch, this.startResultIndex).pipe(
      map((res: any) => {
        const adaptedData = res.hits.hits.map((item: any) => {
          return {
            type: item.data.type,
            title: item.data.title,
            shortDescription: item.data.service_short_description,
            category: item.data.service_category,
            path: item?.data?.path?.alias,
          };
        });
        return adaptedData;
      })
    ).subscribe((result: ServiceSearchResult[]) => {
      if (result?.length < this.itemPerSearch) {
        this.noMoreResults = true;
      } else if (result.length === this.itemPerSearch) {
        // Rimuovo l'ultimo elemento, ma tengo attivo il pulsante carica altri elementi
        result.pop();
      }
      if (this._searchResults().length) {
        this._searchResults.update(searchArr => {
          searchArr = [...searchArr, ...result];
          this.startResultIndex = searchArr.length;
          return searchArr;
        });
      } else {
        this._searchResults.set(result);
        this.startResultIndex = result.length;
      }
      this.loading.set(false);
    }
    );
  }
}
